module.exports = __webpack_public_path__ + "static/img/enrolment-bg.10fbd9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enrolment-bg.jpg
// module id = ckKA
// module chunks = 1